// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__QfjQK","inner":"Footer_inner__3WuNK"};